export type LanguageCode = "tr" | "en";

export const normalizeLanguage = (language?: string): LanguageCode => {
  if (!language) return "tr";
  return language.toLowerCase().startsWith("en") ? "en" : "tr";
};
